import { required } from '@rxweb/reactive-form-validators';

export class RutasModel {
    @required()
    name: string;

    @required()
    description: string;

    @required()
    active: string;
}
